import React from "react";
import Styles from './styles.module.scss'
import {useTranslation} from "react-i18next";



const WpS1 = () => {
    const { t } = useTranslation();

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap} ${Styles.pageContainer}`}>
                <div className={`${Styles.titleWrap}`}>
                    <div className={`${Styles.title}`}>WHITE PAPER</div>
                </div>
                <div className={`${Styles.subTitle}`}>TIME CAPSULE</div>
                <ul className={`${Styles.listWrap}`}>
                    <li className={`${Styles.listWrapItem}`}>{t('Токен')}: $TC</li>
                    <li className={`${Styles.listWrapItem}`}>{t('Стандарт')}: BEP-20</li>
                    <li className={`${Styles.listWrapItem}`}>{t('Сеть')}: BNB Smart Chain (BSC)</li>
                </ul>
                <div className={`${Styles.note}`}>{t('“Когда мир становится хрупким, единственной устойчивой формой вечности может стать цифровая реальность.”')}</div>
            </div>
        </section>
    );
};

export default WpS1;